import { TemplatePage } from './types';

const productDemoPage: TemplatePage = {
  header: {
    color: '#F8D1CA',
    icon: 'images/video-templates/product_demo.jpg',
    title: 'Product Demo Video Templates',
    title_meta: '50+ Free & Editable Product Demo Video Templates',
    description_meta:
      'Your product demo videos won’t go unnoticed if you create them using video templates by Wave.video. ' +
      'Get dozens of free templates to kick-off the video production.',
    description:
      "Showcase your products using customers' most desired format - videos. Boost brand awareness and jack up " +
      'sales making stunning videos from these video templates. '
  },
  footer: {
    category: 'Product Demo',
    description:
      'Wave.video online video editor comes with hundreds of video templates to bring away all the worries of ' +
      'non-designers. These professionally made and fully customizable videos are meant to reduce the time and ' +
      'resources spent on video production. No need to learn complicated video editing software –   better focus ' +
      'on your offering and message. Great video content comes naturally with Wave.video templates.'
  },
  content: [
    {
      type: 'templates',
      title: 'Product Demo Videos',
      search: { category: '/Use Cases/Product Demo' }
    },
    {
      type: 'stocks',
      title: 'product demo',
      search: { name: 'product demo' }
    },
    { type: 'calendar' }
  ]
};

export default productDemoPage;
